import Vue from 'vue';
import { filter, uniq } from 'lodash';

import { ngVueEventBus, EVENT_SAVED_INSIGHTS_UPDATED } from '@/angularBridgeCode/utilities/ngVueEventBus';
import { INSIGHT_REPORT_TYPE, CALLLOG_REPORT_TYPE, getDefaultCallLogData } from './state';
import {
  SET_CURRENT_VIEW,
  RELOAD_INSIGHTS_GRID_DATA,
  SET_INSIGHT_REPORT_TYPE,
  SET_CALLLOG_REPORT_TYPE,
  SET_INSIGHTS_COL_DEFS,
  SET_INSIGHTS_TAGS,
  SET_DEFAULT_INSIGHT_ACTIVE,
  SET_DEFAULT_CALLLOG_ACTIVE,
  SET_ACTIVE_INSIGHT,
  SET_ACTIVE_CALLLOG,
  SET_SAVED_INSIGHTS,
  SET_SAVED_INSIGHT,
  DUPLICATE_SAVED_INSIGHT,
  DELETE_SAVED_INSIGHT,
  SET_GROUP_BY_INSIGHT_SETTINGS,
  SET_SELECTED_GROUP_BY,
  SET_CALLLOG_NAME,
  SET_CALLLOG_FILTER_CRITERIA,
  SET_CALLLOG_DATE_RANGE,
  SET_CALLLOG_AUTO_RELOAD,
  SET_CALLLOG_GRID_STATE,
  SET_CALLLOG_SAVED_VISIBILITY,
  SET_INSIGHT_NAME,
  SET_INSIGHT_FILTER_CRITERIA,
  PREPEND_AND_FILTER_CRITERIA,
  PREPEND_AND_FILTER_CRITERIA_TO_CALL_LOG,
  SET_INSIGHT_LAST_UPDATED_AT,
  SET_CALL_LOG_LAST_UPDATED_AT,
  SET_INSIGHT_DATE_RANGE,
  SET_INSIGHT_AUTO_RELOAD,
  SET_INSIGHT_SAVED_VISIBILITY,
  SET_INSIGHT_GRID_STATE,
  SET_INSIGHT_SELECTED_CHART_TYPE,
  UPDATE_GRID_ROW_GROUPS,
  DELETE_GRID_ROW_GROUP,
  RESET_INSIGHT_SETTINGS,
  SET_CHART_DRILLDOWN_STATE,
  SET_CHART_DRILLDOWN_DATA,
  SET_CHART_LOADER_STATUS,
  SET_CHART_DATA,
  SET_CHART_ALL_PARAMETERS,
  SET_CHART_SELECTED_PARAMETERS,
  SET_EXPORT_FOR_AG_GRID,
  SET_GROUP_BY_INSIGHT_DATA,
  SET_INSIGHT_TIMEZONE_ID,
  SET_CALLLOG_TIMEZONE_ID,
  SET_CALLLOG_HISTOGRAM_DATA,
  SET_CALLLOG_HISTOGRAM_LOADER_STATUS,
  SET_CALLLOG_HISTOGRAM_GROUPING,
  SET_CALL_LOGS_COL_DEFS,
  APPEND_TO_CALL_LOGS_DATA,
  SET_INSIGHTS_DATA_CACHE,
  SET_GRID_ROW_GROUPS,
  RELOAD_CALL_LOGS_GRID_DATA,
  SET_CALL_LOG_DETAILS,
  CLEAR_ACTIVE_INSIGHT_EXPANDED_GROUP_IDS,
  CLEAR_INSIGHTS_DATA_CACHE,
  SET_CALL_LOGS_VISIBILITY_SECTION,
  SET_CALL_LOGS_QUICK_INSIGHTS_DATA_CACHE,
  SET_CALL_LOGS_HISTOGRAM_DATA_CACHE,
  SET_TAG_AUTOCOMPLETE_VALUES,
  RESET_TAG_AUTOCOMPLETE_VALUES,
  SET_CALL_LOGS_VIEW_AS,
  SET_CALL_FIELD_AUTOCOMPLETE_VALUES,
  RESET_CALL_FIELD_AUTOCOMPLETE_VALUES,
  RESET_CALL_LOG_DETAILS,
  APPEND_CALL_FIELD_AUTOCOMPLETE_VALUES,
  APPEND_TAG_AUTOCOMPLETE_VALUES,
  SET_CALLLOG_QUICK_INSIGHTS_TAB,
  SET_CALLLOG_QUICK_INSIGHTS_COLUMN_STATE,
  SET_CALL_LOG_EXPORT_LOADER_VISIBILITY,
  SET_CALL_LOGS_COL_DEFS_LOADED_FROM_API,
  SET_INSIGHTS_COL_DEFS_LOADED_FROM_API,
} from './mutationTypes';

import { getInitialInsight } from './state';
import { differenceWith } from 'lodash';

function removeEmptyAndFilters(filterCriteria) {
  return filterCriteria.filter((criteria) => {
    return criteria?.tagCriteria?.length;
  });
}

export default {
  [SET_CURRENT_VIEW](state, view) {
    state.currentView = view;
  },

  [RELOAD_INSIGHTS_GRID_DATA](state) {
    state.insight.data[state.insight.activeId].refreshGridData++;
  },

  [SET_INSIGHT_REPORT_TYPE](state) {
    state.insight.reports[state.insight.activeId].reportType = INSIGHT_REPORT_TYPE;
  },

  [SET_CALLLOG_REPORT_TYPE](state) {
    state.callLog.reports[state.callLog.activeId].reportType = CALLLOG_REPORT_TYPE;
  },

  [SET_INSIGHTS_COL_DEFS](state, colDefs) {
    state.insight.colDefs = colDefs || [];
  },

  [SET_INSIGHTS_TAGS](state, tags) {
    const result = [];
    const set = new Set();
    for (const tag of tags) {
      const key = `${tag.tagSource}:${tag.tagType}:${tag.tagName}`;
      if(!set.has(key)){
        set.add(key);
        result.push(tag);
      }
    }

    state.tags = result;
  },

  [SET_ACTIVE_INSIGHT](state, insight) {
    state.insight.activeId = insight.id || 'unsaved';
    Vue.set(state.insight.reports, state.insight.activeId, insight);
  },

  [SET_ACTIVE_CALLLOG](state, callLog) {
    state.callLog.activeId = callLog.id || 'unsaved';
    Vue.set(state.callLog.reports, state.callLog.activeId, callLog);
    Vue.set(state.callLog.data, state.callLog.activeId, getDefaultCallLogData());
  },

  [SET_SAVED_INSIGHTS](state, savedInsights) {
    state.savedInsights = savedInsights;
    ngVueEventBus.$emit(EVENT_SAVED_INSIGHTS_UPDATED);
  },
  [SET_SAVED_INSIGHT](state, insight){
    // wonder if filter(state.savedInsights, (i) => i !== insight.id).push(insight) is faster here...
    state.savedInsights = [...filter(state.savedInsights, (i) => i.id !== insight.id), insight];
    ngVueEventBus.$emit(EVENT_SAVED_INSIGHTS_UPDATED);
  },
  [DUPLICATE_SAVED_INSIGHT](state, insight){
    state.savedInsights = [...filter(state.savedInsights, (i) => i.id !== insight.id), insight];
    ngVueEventBus.$emit(EVENT_SAVED_INSIGHTS_UPDATED);
  },
  [DELETE_SAVED_INSIGHT](state, insightId){
    state.savedInsights = filter(state.savedInsights, (i) => i.id !== insightId);
    ngVueEventBus.$emit(EVENT_SAVED_INSIGHTS_UPDATED);
  },
  [SET_CALLLOG_NAME](state, name) {
    state.callLog.reports[state.callLog.activeId].name = name;
  },
  [SET_CALLLOG_FILTER_CRITERIA](state, filterCriteria) {
    state.callLog.reports[state.callLog.activeId].settings.filterCriteria = filterCriteria;
  },
  [SET_CALLLOG_DATE_RANGE](state, dateRangeDetails) {
    const settings = state.callLog.reports[state.callLog.activeId].settings;
    settings.dateRange = {
      ...settings.dateRange,
      ...dateRangeDetails
    };
  },
  [SET_CALLLOG_AUTO_RELOAD](state, autoReload) {
    state.callLog.reports[state.callLog.activeId].settings.autoReload = autoReload;
  },
  [SET_CALLLOG_SAVED_VISIBILITY](state, visibleAccountWide) {
    state.callLog.reports[state.callLog.activeId].visibleAccountWide = visibleAccountWide;
  },
  [SET_CALLLOG_GRID_STATE](state, gridState) {
    state.callLog.reports[state.callLog.activeId].settings.gridSettings = gridState;
  },
  [SET_SELECTED_GROUP_BY](state, groupBy) {
    state.insight.reports[state.insight.activeId].settings.selectedGroupBy = groupBy;
  },
  [SET_GROUP_BY_INSIGHT_SETTINGS](state, { groupBySettings }) {
    state.insight.reports[state.insight.activeId].settings.groupSettings = groupBySettings;
  },
  [SET_DEFAULT_INSIGHT_ACTIVE](state) {
    state.insight.activeId = 'unsaved';
  },
  [SET_DEFAULT_CALLLOG_ACTIVE](state) {
    state.callLog.activeId = 'unsaved';
  },
  [SET_GROUP_BY_INSIGHT_DATA](state, dataObj) {
    Vue.set(state.insight.data, state.insight.activeId, {
      ...state.insight.data[state.insight.activeId],
      ...dataObj
    });
  },
  [SET_INSIGHT_NAME](state, name) {
    state.insight.reports[state.insight.activeId] = {
      ...state.insight.reports[state.insight.activeId],
      name
    };
  },
  [SET_INSIGHT_FILTER_CRITERIA](state, filterCriteria) {
    state.insight.reports[state.insight.activeId].settings.filterCriteria = filterCriteria;
  },
  [PREPEND_AND_FILTER_CRITERIA](state, filterCriteria) {
    const filtersToAdd = differenceWith(filterCriteria, state.insight.reports[state.insight.activeId].settings.filterCriteria, (a, b) => {
      return a.tagCriteria && b.tagCriteria
        && a.tagCriteria.length === 1 && b.tagCriteria.length === 1
        && a.tagCriteria[0].tagId === b.tagCriteria[0].tagId
        && a.tagCriteria[0].value === b.tagCriteria[0].value;
    });

    const existingFilterCriteria = state.insight.reports[state.insight.activeId].settings.filterCriteria;
    const existingFiltersSanitized = removeEmptyAndFilters(existingFilterCriteria);
    
    state.insight.reports[state.insight.activeId].settings.filterCriteria = [
      ...filtersToAdd,
      ...existingFiltersSanitized
    ];
  },
  [PREPEND_AND_FILTER_CRITERIA_TO_CALL_LOG](state, filterCriteria) {
    const filtersToAdd = differenceWith(filterCriteria, state.insight.reports[state.insight.activeId].settings.filterCriteria, (a, b) => {
      return a.tagCriteria && b.tagCriteria
        && a.tagCriteria.length === 1 && b.tagCriteria.length === 1
        && a.tagCriteria[0].tagId === b.tagCriteria[0].tagId
        && a.tagCriteria[0].value === b.tagCriteria[0].value;
    });
    const existingFilterCriteria = state.callLog.reports[state.callLog.activeId].settings.filterCriteria;
    const existingFiltersSanitized = removeEmptyAndFilters(existingFilterCriteria);
    
    state.callLog.reports[state.callLog.activeId].settings.filterCriteria = [
      ...filtersToAdd,
      ...existingFiltersSanitized
    ];
  },
  [SET_INSIGHT_LAST_UPDATED_AT](state, lastUpdated) {
    state.insight.data[state.insight.activeId].lastUpdated = lastUpdated || new Date();
  },
  [SET_CALL_LOG_LAST_UPDATED_AT](state) {
    state.callLog.data[state.callLog.activeId].lastUpdated = new Date();
  },
  [SET_INSIGHT_DATE_RANGE](state, dateRangeDetails) {
    const settings = state.insight.reports[state.insight.activeId].settings;
    settings.dateRange = {
      ...settings.dateRange,
      ...dateRangeDetails
    };
  },
  [SET_INSIGHT_AUTO_RELOAD](state, autoReload) {
    state.insight.reports[state.insight.activeId].settings.autoReload = autoReload;
  },
  [SET_INSIGHT_SAVED_VISIBILITY](state, visibleAccountWide) {
    state.insight.reports[state.insight.activeId].visibleAccountWide = visibleAccountWide;
  },
  [SET_INSIGHT_GRID_STATE](state, gridState) {
    const settings = state.insight.reports[state.insight.activeId].settings;
    settings.groupSettings = {
      ...settings.groupSettings,
      gridState
    };
  },
  [SET_INSIGHTS_COL_DEFS_LOADED_FROM_API](state, loaded) {
    state.insight.colDefsLoadedFromAPI = loaded;
  },
  [CLEAR_ACTIVE_INSIGHT_EXPANDED_GROUP_IDS](state) {
    state.insight.reports[state.insight.activeId].settings.groupSettings.gridState = {
      ...state.insight.reports[state.insight.activeId].settings.groupSettings.gridState,
      id: performance.now(),
      expandedGroupIds: []
    };
  },
  [SET_INSIGHT_SELECTED_CHART_TYPE](state, chartType) {
    state.insight.reports[state.insight.activeId].settings.selectedChartType = chartType;
  },
  [UPDATE_GRID_ROW_GROUPS](state, { groupBy, index }) {
    Vue.set(state.insight.reports[state.insight.activeId].settings.groupSettings.gridState.rowGroupCols,
      index,
      {
        aggFunc: null,
        field: groupBy.field,
        id: groupBy.field,
        displayName: groupBy.displayName
      });
  },
  [DELETE_GRID_ROW_GROUP](state, index) {
    const gridState = state.insight.reports[state.insight.activeId].settings.groupSettings.gridState;
    Vue.set(gridState,
      'rowGroupCols',
      gridState.rowGroupCols.filter((e, i) => i != index));
  },
  [SET_GRID_ROW_GROUPS](state, rowGroups) {
    state.insight.reports[state.insight.activeId].settings.groupSettings.gridState.rowGroupCols = rowGroups;
  },
  [RESET_INSIGHT_SETTINGS](state) {
    const initialInsightSettings = getInitialInsight();
    const activeInsightSettings = state.insight.reports[state.insight.activeId];
    for (const p in activeInsightSettings) {
      Vue.set(activeInsightSettings, p, initialInsightSettings[p]);
    }
  },
  [SET_CHART_DRILLDOWN_STATE](state, { drilleddownTo, chartType }) {
    Vue.set(state.insight.reports[state.insight.activeId].settings.groupSettings.chartStates[chartType], 'drilleddownTo', drilleddownTo);
  },

  [SET_CHART_DRILLDOWN_DATA](state, { chartType, chartPoint, aggregatedData }) {
    const insightChartData = state.insight.data[state.insight.activeId].chartData[chartType];
    insightChartData.drilleddownData = {
      ...insightChartData.drilleddownData,
      [chartPoint.id]: {
        point: chartPoint,
        data: aggregatedData
      }
    };
  },

  [SET_CHART_LOADER_STATUS](state, { chartType, showLoader }) {
    state.insight.data[state.insight.activeId].chartData[chartType].showLoader = showLoader;
  },

  [SET_CHART_DATA](state, { chartType, data }) {
    const chartData = state.insight.data[state.insight.activeId].chartData;
    if (chartData) {
      chartData[chartType].defaultData = data;
    }
  },

  [SET_CHART_ALL_PARAMETERS](state, { allParameters }) {
    state.insight.data[state.insight.activeId].chartAllParameters = allParameters;
  },

  [SET_CHART_SELECTED_PARAMETERS](state, { selectedParameters }) {
    state.insight.reports[state.insight.activeId].settings.groupSettings.chartStates.selectedParameters = [...selectedParameters];
  },

  [SET_EXPORT_FOR_AG_GRID](state, { shouldExport, params }) {
    state.exportInsightData = { shouldExport, params };
  },

  [SET_INSIGHT_TIMEZONE_ID](state, timeZoneId) {
    state.insight.reports[state.insight.activeId].settings.dateRange.timeZoneId = timeZoneId;
  },

  [RELOAD_CALL_LOGS_GRID_DATA](state) {
    state.callLog.data[state.callLog.activeId].refreshGridData++;
  },

  [SET_CALLLOG_TIMEZONE_ID](state, timeZoneId) {
    state.callLog.reports[state.callLog.activeId].settings.dateRange.timeZoneId = timeZoneId;
  },

  [SET_CALLLOG_HISTOGRAM_DATA](state, data) {
    state.callLog.data[state.callLog.activeId].histogram = Object.freeze(data);
  },

  [SET_CALLLOG_HISTOGRAM_LOADER_STATUS](state, loaderStatus) {
    state.callLog.data[state.callLog.activeId].showHistogramLoader = loaderStatus;
  },

  [SET_CALLLOG_HISTOGRAM_GROUPING](state, timeGroup) {
    state.callLog.reports[state.callLog.activeId].settings.histogramSettings.groupTimeInterval = timeGroup;
  },

  [SET_CALL_LOGS_COL_DEFS](state, colDefs) {
    state.callLog.colDefs = colDefs;
  },

  [SET_CALL_LOGS_COL_DEFS_LOADED_FROM_API](state, loaded) {
    state.callLog.colDefsLoadedFromAPI = loaded;
  },

  [APPEND_TO_CALL_LOGS_DATA](state, data) {
    state.callLog.data[state.callLog.activeId].callLogs = Object.freeze([...state.callLog.data[state.callLog.activeId].callLogs, ...data]);
  },

  [SET_INSIGHTS_DATA_CACHE](state, { data, cacheKey, totalsRecord, partialResult, lastUpdated }) {
    state.insight.data[state.insight.activeId].dataCache = {
      data: Object.freeze(data),
      cacheKey,
      totalsRecord,
      partialResult,
      lastUpdated
    };
  },

  [CLEAR_INSIGHTS_DATA_CACHE](state) {
    state.insight.data[state.insight.activeId].dataCache = {};
  },

  [SET_CALL_LOG_DETAILS](state, { callId, callDetails }) {
    Vue.set(state.callLog.data[state.callLog.activeId].callLogDetails, callId, Object.freeze(callDetails));
  },

  [RESET_CALL_LOG_DETAILS](state) {
    state.callLog.data[state.callLog.activeId].callLogDetails = {};
  },

  [SET_CALL_LOGS_VISIBILITY_SECTION](state, { section, visible }) {
    state.callLog.sectionsVisibility[section] = visible;
  },

  [SET_CALL_LOGS_QUICK_INSIGHTS_DATA_CACHE](state, { data, cacheKey, totalsRecord, partialResult, lastUpdated }) {
    state.callLog.data[state.callLog.activeId].dataCache.quickInsights[cacheKey] = {
      data: Object.freeze(data),
      cacheKey,
      totalsRecord: Object.freeze(totalsRecord),
      partialResult,
      lastUpdated
    };
  },

  [SET_CALL_LOGS_HISTOGRAM_DATA_CACHE](state, { data, cacheKey, partialResult, lastUpdated }) {
    state.callLog.data[state.callLog.activeId].dataCache.histogram[cacheKey] = {
      data: Object.freeze(data),
      cacheKey,
      partialResult,
      lastUpdated
    };
  },

  [SET_TAG_AUTOCOMPLETE_VALUES](state, { tagType, tagName, values }) {
    Vue.set(state.tagAutoCompleteValues, `${tagType}/${tagName}`, values);
  },

  [APPEND_TAG_AUTOCOMPLETE_VALUES](state, { tagType, tagName, values }) {
    const tagId = `${tagType}/${tagName}`;
    if (state.tagAutoCompleteValues[tagId]) {
      state.tagAutoCompleteValues[tagId] = uniq(state.tagAutoCompleteValues[tagId].concat(values));
    } else {
      Vue.set(state.tagAutoCompleteValues, tagId, values);
    }
  },

  [SET_CALL_FIELD_AUTOCOMPLETE_VALUES](state, { fieldName, values }) {
    Vue.set(state.fieldAutoCompleteValues, fieldName, values);
  },

  [APPEND_CALL_FIELD_AUTOCOMPLETE_VALUES](state, { fieldName, values }) {
    if (state.fieldAutoCompleteValues[fieldName]) {
      state.fieldAutoCompleteValues[fieldName] = uniq(state.fieldAutoCompleteValues[fieldName].concat(values));
    } else {
      Vue.set(state.fieldAutoCompleteValues, fieldName, values);
    }
  },

  [RESET_TAG_AUTOCOMPLETE_VALUES](state) {
    state.tagAutoCompleteValues = {};
  },

  [RESET_CALL_FIELD_AUTOCOMPLETE_VALUES](state) {
    state.fieldAutoCompleteValues = {};
  },

  [SET_CALL_LOGS_VIEW_AS](state, viewAs) {
    Vue.set(state.callLog.reports[state.callLog.activeId].settings, 'viewAs', viewAs);
  },

  [SET_CALLLOG_QUICK_INSIGHTS_TAB](state, groupingColId) {
    const activeCallLogSettings = state.callLog.reports[state.callLog.activeId].settings;
    
    if (activeCallLogSettings?.quickInsightsSettings) {
      Vue.set(activeCallLogSettings.quickInsightsSettings, 'selectTabGrouping', groupingColId);
    } else {
      Vue.set(activeCallLogSettings, 'quickInsightsSettings', {
        selectTabGrouping: groupingColId
      });
    }
  },

  [SET_CALLLOG_QUICK_INSIGHTS_COLUMN_STATE](state, columnState) {
    const activeCallLogSettings = state.callLog.reports[state.callLog.activeId].settings;

    if (activeCallLogSettings?.quickInsightsSettings) {
      Vue.set(activeCallLogSettings.quickInsightsSettings, 'columnState', columnState);
    } else {
      Vue.set(activeCallLogSettings, 'quickInsightsSettings', {
        columnState,
      });
    }
  },

  [SET_CALL_LOG_EXPORT_LOADER_VISIBILITY](state, visibility) {
    state.callLog.showExportLoader = visibility;
  },

  reset: () => {}
};